var render = function render(_c,_vm){return _c('div',{staticClass:"grid-view__cell",class:{
    ...(_vm.data.staticClass && {
      [_vm.data.staticClass]: true,
    }),
  }},[_c('div',{staticClass:"grid-field-rating"},[_c(_vm.$options.components.Rating,{tag:"component",attrs:{"read-only":true,"rating-style":_vm.props.field.style,"color":_vm.props.field.color,"value":_vm.props.value,"max-value":_vm.props.field.max_value}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }